import { render, staticRenderFns } from "./SubjectCategoryTable.vue?vue&type=template&id=56b03381"
import script from "./SubjectCategoryTable.vue?vue&type=script&lang=js"
export * from "./SubjectCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports